<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 11H11V4H13.0001V11H20.0001V12.9999H13.0001V19.9998H11V12.9999H4V11Z"
    />
  </svg>
</template>
